export default __webpack_public_path__ + "static/media/nectar-logo.0b3e3493.svg";